import { Box } from "@mui/material";
import WithLove from "../../common/components/WithLove";
import Topic from "../../common/components/Topic";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
import Number from "../../common/components/Number";
import Italics from "../../common/components/Italics";

// Images Import
// import cover from "../../images/6.0/day3/Cover Image.jpg";

import cover from "../../images/5.0/day3/0. Introduction.png";
import tabernacle from "../../images/5.0/day3/2. Tabernacle.png";
import ordinance from "../../images/5.0/day3/3. Ordinance.png";
import defining from "../../images/5.0/day3/4. Defining.png";
import salvation from "../../images/5.0/day3/5. Salvation.png";
import caseForSalvation from "../../images/5.0/day3/6. case.png";
import romans from "../../images/5.0/day3/7. Romans.png";
import allegories from "../../images/5.0/day3/8. Allegories.png";
import Picture from "../../common/components/Picture";

export default function DayThree() {
  return (
    <>
      <Box>
        <Topic>The Perfect Will</Topic>
        <Text>Romans 12:1-2, Colossians 1:9-11, Isaiah 61:1-3</Text>
        <br />
      </Box>

      {/* Cover Image */}
      <Picture src={cover} />

      <Section>
        {/* Section 1: Introduction */}
        <Section>
          <Title>1. Introduction</Title>
          <Content>
            We thank God for the great understanding that has come to us in the
            last two lessons of this study. We have taken an in-depth look at
            the volume of His beautiful will. We have seen that the will of God
            are His laws, which will make us exactly like Him. In our journey
            into His will, we first encounter the will of the Lord, which makes
            us both good and acceptable by the laws of Faith.
          </Content>
          <Content>
            In this final instalment, we will take a look at the perfect will of
            God.
          </Content>
        </Section>

        {/* Section 2: A Look at the Tabernacle of Moses */}
        <Section>
          <Title>2. A Look at the Tabernacle of Moses</Title>
          <Picture src={tabernacle} />
          <Content>
            There are certain biblical allegories we need to understand to be
            able to accurately conceive the program of God for man. One of such
            key allegories is the tabernacle of Moses <b>(Exodus 25:8-9)</b>.
            This is because the tabernacle shows us the order of the heavens,
            the divisions of the kingdom, and the ordinance of worship{" "}
            <b>(Heb 8:5, 9:1)</b>. Much more, it shows us the progression of the
            journey of a believer.
          </Content>
          <Content>
            Recall that the tabernacle was divided into three places: court,
            sanctuary or holy place, and holiest of all or true tabernacle{" "}
            <b>(Heb 9:1-5, Exo 27:9)</b>. The tabernacle was a physical
            animation of the kingdom of God, which are righteousness, peace, and
            Joy, respectively. Interestingly, these places were separated by
            veils, showing that they are distinct places in the kingdom of God{" "}
            <b>(Heb 9:3)</b>.
          </Content>
          <Content>
            The tabernacle was a house of sacrifice, from the court to the
            sanctuary and the holiest <b>(Heb 9:9)</b>. This means that it is
            only people of the will that serve the tabernacle because, recall,
            we said that the will are the laws of God's sacrifices{" "}
            <b>(Psalm 40:6-8)</b>. Thus, not just anyone was allowed within the
            holy places, just the priests <b>(Heb 9:6-7)</b>. This shows us that
            it would take doing sacrifices of the will to draw near to God{" "}
            <b>(Psalm 50:5)</b>.
          </Content>
          <Content>
            The people who were allowed within these holy places were Levites,
            Priests, and the High Priest, respectively. While the Levites were
            allowed to come near into the court, only the priests (sons of
            Aaron) could go further into the sanctuary. However, it was only the
            High Priest (Aaron) who could go into the holiest{" "}
            <b>(Psalm 135:1-2, 134:1-2, 133:2, Num 3:6-8a, Heb 9:6-7)</b>. This
            is symbolic of the different degrees of the will of God: good,
            acceptable, and perfect. Hence, we can say that the Levites are
            good, the priests are acceptable, and the High Priest is perfect in
            the sight of God. It is good to know that these different kinds of
            priests are shadows of the manner of persons that the believer is
            expected to become on his journey through all the will of God. It is
            clear that the will of God transforms a believer into persons worthy
            of the kingdom.
          </Content>
          <Content>
            Most importantly, David showed us in the Psalms that the tabernacle
            can be traversed, i.e. a man can journey into these holy places.
            Thus making it not just a monument of worship and service, but a
            pattern that explains the journey of a soul to God, who dwelt in the
            holiest of all <b>(Psalm 5:7, 43:3, 15:1-5, 24:1-4)</b>. In other
            words, the Lord expects men to journey into his tabernacle. The
            vehicle of movement into the tabernacle or the kingdom is the will
            that transforms our souls.
          </Content>
          <Content>
            This means the believer must journey from the camp, into the court,
            then into the sanctuary, and into the most holy place, to stand in
            the presence of God, where there is fullness of Joy{" "}
            <b>(Psalm 16:11)</b>.
          </Content>
        </Section>

        {/* Section 3: Comparing the Ordinance of Sacrifice with the Program of the Will */}
        <Section>
          <Title>
            3. Comparing the Ordinance of Sacrifice with the Program of the Will
          </Title>{" "}
          <Picture src={ordinance} />
          <Content>
            We find an interesting comparison between the ordinance of coming
            and the implementation of the program of the will in{" "}
            <b>Isaiah 61:1-3</b>.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>A. The Ordinance of Coming</Subtitle>
              Interestingly, we find that there is an ordinance for approaching
              the tabernacle under the old covenant. This pattern was such that
              the priests came into the sanctuary <b>"always"</b> throughout the
              year. Meanwhile, the High Priest enters the holiest of all{" "}
              <b>"once"</b> every year <b>(Heb 9:6-7)</b>. This day is described
              as the <b>"Great Day of Atonement" (Lev 23:27)</b>. This is
              insightful to show us that while the sanctuary is always
              accessible, the holiest is only accessible "once" in a year. Thus,
              we may conclude that the program of service and sacrifice is
              intended to culminate in a day: the Great Day of Atonement, when
              the way into the holiest is open, and the High Priest can approach
              God.
            </Content>
            <Content>
              <b>Key lesson.</b> When we compare this pattern with{" "}
              <b>Isaiah 61:1-3</b>, we find that the program of the will is also
              intended to culminate in a day, which is the{" "}
              <b>"Day of the Vengeance of God"</b>. Thus, while the season of
              the Lord is described using the timing of "year", the season of
              God is described using the timing of a "day". This is not a
              coincidence, but shows us a pattern of understanding.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. The Great Day of Atonement</Subtitle>
              The great day of atonement is the day when the High Priest
              approaches the presence of God for the sake of the people. The
              exact moment when this day begins can be understood as the
              accepted time, which is the time the veil to the holiest is open
              and the High Priest can enter. This day is intended by God to
              cover the sins of the people for one year. However, Paul explains
              to us that this ordinance could not perfect them, meaning it was
              intended for perfection <b>(Heb 10:1-3)</b>. In other words, the
              program of sacrifice is intended to culminate in a day when the
              "comers" would be perfected or cleansed from all sin and iniquity{" "}
              <b>(Lev 16:1-34)</b>.
            </Content>
            <Content>
              <b>Key lesson.</b> When we compare this pattern with the program
              of the will, we can understand that the Day of God is intended for
              Perfection!
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>
                C. Transitioning from the Acceptable Year of the Lord into the
                Day of God
              </Subtitle>
            </Content>
            <Italics>
              Isaiah 61:1-2 — The Spirit of the Lord GOD is upon me; because the
              LORD hath anointed me to preach good tidings unto the meek; he
              hath sent me to bind up the brokenhearted, to proclaim liberty to
              the captives, and the opening of the prison to them that are
              bound; To proclaim the acceptable year of the LORD, and the day of
              vengeance of our God; to comfort all that mourn.
            </Italics>
            <Content>
              Recall that the believer begins the journey in the administration
              of the Lord from the opening of the eyes to discern the good,
              which then leads to removing the chains that hold the soul to the
              earth (lusts of the flesh), then leads to delivering the soul from
              being a prisoner of hope (lust of the eyes). This journey in the
              good culminates in the court. Thus, we can say the good (faith and
              hope) brings the soul out of the world to the court of the
              tabernacle. This makes the believer a Levite or holy. Then, the
              season of the acceptable (charity) takes the soul nearer, from the
              court into the sanctuary and culminates at the veil. This makes
              the believer a priest or clean.
            </Content>
            <Content>
              A <b>1 Corinthians 13:7-11</b> man is a New Testament priest of
              the Lord who stands by night in the sanctuary or holy place.
              However, there still remains the day of God ahead of this man. He
              cannot move ahead into the holiest without the veil being opened.
              Hence, he has to wait in the sanctuary. He is acceptable but has
              to wait to be accepted into the holiest of all to be perfected.
              The moment when the veil opens is called the <b>time accepted</b>.
              This is the time chosen by God to receive acceptable souls into
              the holiest of all.
            </Content>
          </SubSection>
        </Section>

        {/* Section 4: Defining the Accepted Time */}
        <Section>
          <Title>4. Defining the Accepted Time</Title>{" "}
          <Picture src={defining} />
          <Italics>
            2 Corinthians 6:2 — For he saith, I have heard thee in a time
            accepted, and in the day of salvation have I succoured thee: behold,
            now is the accepted time; behold, now is the day of salvation.
          </Italics>
          <Content>
            Paul, as a sound minister of the will, understood the program of
            God's will and gave us insight into understanding the program of the
            will in the Epistles. Here in <b>2 Cor 6:2</b>, he describes the
            accepted time as a time that precedes the day of salvation. This is
            the time when the souls in the holy place or sanctuary are accepted
            into the holiest of all for the program of salvation to begin.
          </Content>
          <SubSection>
            <Subtitle>What exactly happens in the accepted time?</Subtitle>
            <Italics>
              Hebrews 9:28 — So Christ was once offered to bear the sins of
              many; and unto them that look for him shall he appear the second
              time without sin unto salvation.
            </Italics>
            <Italics>
              Hebrews 2:10 — For it became him, for whom are all things, and by
              whom are all things, in bringing many sons unto glory, to make the
              captain of their salvation perfect through sufferings.
            </Italics>
            <Content>
              In the scriptures, we find many places that point to the accepted
              time. In all these places, we find a consistent description. This
              description is such that shows us that it would take the High
              Priest coming into the sanctuary to take the acceptable souls into
              the holiest. The acceptable souls cannot by themselves enter into
              the holiest. It would take the High Priest to escort them in. Our
              High Priest in the New Testament is Jesus, the Son of God.
            </Content>
            <Content>
              One of the most detailed descriptions of the "accepted time" is in{" "}
              <b>Malachi 3:1-3</b>. This portion of scripture shows us that the
              messenger of the covenant, figurative of our Lord Jesus, will come
              into his temple (sanctuary or holy place) to refine and purify the
              sons of Levi or priests by fire so that they can enter into the
              holiest of all. The purification is to make them fit for the
              holiest or the day of God.
            </Content>
            <Content>
              This scripture also shows us parameters to identify acceptable
              souls. They are earnestly seeking for and delight in the Lord so
              that he can appear. We can thus see that it is the passion and
              seeking of the Lord that caused him to appear unto them. In sum,
              acceptable souls are souls that seek the Lord with all their
              hearts. This is because they have been purified from worldly lusts
              and ungodliness by righteousness and godliness (peace){" "}
              <b>(Tit. 2:11-13)</b>.
            </Content>
            <Content>
              This purging rebirths them into newborn babes, ready for the day
              of God. The Day of God is the day these newborn souls are expected
              to engage the will of God, which is good, acceptable, and perfect.
              It is good to mention that all of these stages are all in
              Perfection. The holiest of all is where the soul is taught to be
              free from iniquity <b>(Tit 2:11-14)</b>.
            </Content>
          </SubSection>
        </Section>

        {/* Section 5: The Day of God is also the Day of Salvation */}
        <Section>
          <Title>5. The Day of God is Also the Day of Salvation</Title>{" "}
          <Picture src={salvation} />
          <Italics>
            2 Corinthians 6:2 — For he saith, I have heard thee in a time
            accepted, and in the day of salvation have I succoured thee: behold,
            now is the accepted time; behold, now is the day of salvation.
          </Italics>
          <Content>
            Paul further gives us more insight into the Day of God because Paul
            calls it the Day of Salvation. Thus, we can easily conclude that the
            Day of the Vengeance of God is also a day of salvation. Thus,
            perfection is the description of the salvation of the soul. This
            salvation is actually the finality of the working of the will of God
            in the soul. The soul is saved by the doing of all the will of God:
            good, acceptable, and perfect. This is also why the will of God is
            called the volume of his beautiful will. We find in scriptures that
            beauty is salvation because the meek will He{" "}
            <b>"beautify with salvation" (Psalm 149:4)</b>. The meek "here"
            describes the newborn babes born by fire. Thus, a saved soul is a
            perfected soul or a beautified soul. Salvation is a heavenly nature
            that is incorruptible, undefiled, and fades not away{" "}
            <b>(1 Pet 1:3-5)</b>.
          </Content>
        </Section>

        {/* Section 6: A Case for the Salvation of the Soul */}
        <Section>
          <Title>6. A Case for the Salvation of the Soul</Title>
          <Picture src={caseForSalvation} />
          <Italics>
            "receiving the end of your faith, even the salvation of your souls."
            — 1 Peter 1:9
          </Italics>
          <Italics>
            "And the very God of peace sanctify you wholly; and I pray God your
            whole spirit and soul and body be preserved blameless unto the
            coming of our Lord Jesus Christ." — 1 Thessalonians 5:23
          </Italics>
          <Content>
            A wrong understanding of man's nature will distort our understanding
            of salvation or redemption. Man is tripartite: Man is a spirit, has
            a soul, and lives in a body. Salvation has to be administered
            uniquely to the tripartite man for it to be whole. This is not hard
            to see, because when a man is regenerated or is "born again", we
            know from the scriptures that he is a new creature somewhere{" "}
            <b>(2 Cor. 5:17)</b>, but he is also unregenerated or an "old man"
            somewhere else <b>(Eph. 4:22)</b>. This is no confusion. According
            to the scriptures, what is regenerated or quickened is the spirit{" "}
            <b>(Eph. 2:1)</b>:
          </Content>
          <Italics>
            "even when we were dead in sins, hath quickened us together with
            Christ, (by grace ye are saved;)" — Ephesians 2:5
          </Italics>
          <Content>
            At the new birth, the unregenerated human spirit undergoes a
            quickening by identifying with the death, burial and resurrection of
            the Lord Jesus Christ. That spirit becomes joined to the Lord{" "}
            <b>(1 Cor. 6:17)</b>, and the spirit is Life <b>(Rom. 8:10)</b>.
          </Content>
          <Content>
            However, the body does not undergo any observable change{" "}
            <b>(Rom. 8:10)</b>, nor does the soul. The new birth is the
            salvation of the spirit. We also see that the redemption of the body
            is spoken of as something that has not yet occurred{" "}
            <b>(Rom. 8:23)</b>.
          </Content>
          <Content>
            Moreover, we also see that the scriptures point us to the fact that
            after the new birth, which is initial salvation (of the spirit), we
            still need to go unto salvation{" "}
            <b>(1 Pet. 1:5, 2 Tim. 3:15, Heb. 9:28)</b>. This means that the new
            birth did not supply to us everything about salvation. The
            scriptures were written by over forty different authors across a
            millennium with vastly different realities and circumstances, but it
            is clear that the entirety of the scriptures carries one central
            thought that has endured for all time:{" "}
            <b>The salvation of the soul</b>. When we closely examine the
            mannerisms and allegories of salvation in scripture, it becomes very
            hard to present and defend a concept of salvation that is without
            journey or process, i.e., instantaneous.
          </Content>
          <Content>
            Salvation is described as having a starting point <b>(Eph. 2:5)</b>,
            an end <b>(2 Tim. 4:7, 1 Pet. 1:9)</b> and milestones along the
            journey <b>(Rom. 13:9)</b>. It then begs the question — what is
            salvation? In <b>Hebrews 1:14</b>, saints are described as heirs of
            salvation. It then means that salvation is an inheritance. This
            inheritance and its characteristics are clearly spelt out in the
            scriptures:
          </Content>
          <Italics>
            "to an inheritance incorruptible, and undefiled, and that fadeth not
            away, reserved in heaven for you," — 1 Peter 1:4
          </Italics>
          <Content>
            Salvation, which is our inheritance in God or that which we should
            journey unto, is incorruptible, undefiled and cannot fade away. It
            will be good to know that nothing in this present creation fits this
            description. In <b>Romans 8:17</b>, we see that it is possible to be
            an heir of God. It means then that God is that inheritance, and to
            buttress this further, we deduce that if the down payment or earnest
            of our inheritance is the Holy Ghost, the third person of the
            Godhead <b>(Eph. 1:14)</b>, then the rest of the inheritance cannot
            be less than this.
          </Content>
          <Content>
            It is important to point out that it is the soul that receives
            inheritance <b>(1 Pet. 1:9)</b>, and inheritance is received
            gradually. The saving of the soul should be an ongoing process for
            every believer <b>(Heb. 10:38-39)</b>.
          </Content>
        </Section>

        {/* Section 7: Taking a Closer Look at Romans 12:2 */}
        <Section>
          <Title>7. Taking a Closer Look at Romans 12:2</Title>{" "}
          <Picture src={romans} />
          <Italics>
            Romans 12:2 — And be not conformed to this world: but be ye
            transformed by the renewing of your mind, that ye may prove what is
            that good, and acceptable, and perfect, will of God.
          </Italics>
          <Content>
            Having established in our previous sessions that the will of God is
            progressive — that is, we go from the will of the Lord to the will
            of God — <b>Isaiah 61:1-2</b> shows that the will of the Lord begins
            with the good will and culminates at the acceptable year of the
            Lord, that is, the acceptable will. This acceptable will, however,
            is the perfection of the will of the Lord which only makes a man
            acceptable unto God <b>(Eph 4:13, Col 1:28, Col 3:14)</b>.
          </Content>
          <Content>
            It is clear that the requirement to prove or accurately discern the
            will of God is to be transformed by the renewing of the mind, as
            against conforming to the world. We see in <b>Ephesians 2:2-3</b>{" "}
            that we walked according to the course of this world, which resulted
            in a work of formation of nature in our souls. This formation is
            what scriptures refer to as the old man, which is corrupt according
            to the deceitful lusts <b>(Eph 4:22)</b>. However{" "}
            <b>Ephesians 4:20-22</b> presents the learning of the Life of Christ
            as the process of putting off the old man and putting on the new
            man, which is created in righteousness and true holiness; speaking
            of the Kingdom of Christ, thereby renewing the spirit of the mind{" "}
            <b>(Eph 4:20, 22-24; Rom 14:17, 8:6)</b>. Therefore, it is the Life
            or Kingdom of Christ, which is obtained by fulfilling the will of
            the Lord, that activates transformation from the world in the soul
            of the believer — with which he would be able to prove the will of
            God. Moreover, <b>Romans 12:2</b> shows that the will of God itself
            is also calibrated in three strata, that is, the good, acceptable
            and perfect will of God.
          </Content>
        </Section>

        {/* Section 8: Allegories of the Accepted Time */}
        <Section>
          <Title>8. Allegories of the Accepted Time</Title>{" "}
          <Picture src={allegories} />
          <Content>
            In Scripture, we see various allegories that point to a time when
            God seeks to receive people into the season of His perfect will.
            These examples reveal that there is a divinely appointed season in
            the Spirit when God admits those who are acceptable to Him, while
            also showing how one may fall short of this privilege.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>A. Cain and Abel</Subtitle>
            </Content>
            <Italics>
              Genesis 4:7 — If thou doest well, shalt thou not be accepted? and
              if thou doest not well, sin lieth at the door. And unto thee shall
              be his desire, and thou shalt rule over him.
            </Italics>
            <Content>
              Over time, Cain and Abel came into a season where they were
              required to present themselves and their offerings before the
              Lord. Scripture makes it clear that there was a process of time —
              a period in which God expected them to walk in and fulfil His
              will. God's concern was not first with the offering they brought,
              but with the offering they had become <b>(Genesis 4:4-5)</b>. Abel
              was accepted because he himself was righteous, a righteousness
              that could only have come through obedience to the will of the
              Lord <b>(Matthew 23:35)</b>. Cain, on the other hand, was not
              accepted because he was evil, doing the works — that is, the will
              — of the devil <b>(Genesis 4:7; 1 John 3:12)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>The Virgins (Matthew 25:1-13)</Subtitle>
            </Content>
            <Content>
              The parable of the ten virgins presents a vivid picture of the
              season of the accepted time. It is important to note from
              Scripture that all ten were virgins, a state that signifies the
              purity of their souls, being separated from the world{" "}
              <b>(2 Corinthians 11:2)</b>. They had been freed from ungodliness
              and worldly lusts, and thus had concluded the good and acceptable
              will of God.
            </Content>
            <Content>
              However, they had not yet entered into the season of the perfect
              will, and were in patience to be admitted into that season.
              Evidently, patience is a necessary requirement to participate in
              the perfect will of God. It reveals that the accepted time is
              orchestrated by the Lord Himself; a believer cannot simply step
              into the season of the perfect will or the day of salvation by
              just his personal readiness, but must be brought into it according
              to His timing. We also see that the bridegroom, which speaks of
              the Son of God, has to receive or admit the believer into this
              next allocation.
            </Content>
            <Content>
              The Son comes like a thief to receive those who are ready.
              Readiness, therefore, is seen in a virgin whose lamp is still
              burning at His appearance. <b>Psalm 119:105</b> reveals the lamp
              as the word of God, while <b>Proverbs 6:23</b> shows it to be the
              commandments of God; yet for the lamp to burn, there must be oil.
              The purpose of the lamp is fulfilled only when it is burning, and
              the oil sustains that burning. To keep the lamp burning, then, is
              to continually obey the will or the commandments of the Lord until
              the accepted time <b>(Luke 12:35–38)</b>. The oil is a secretion
              of the Holy Spirit, enabling the word to be effectual and alive in
              the believer.
            </Content>
            <Content>
              Thus, to be received by God, the obedience that brought one into
              freedom must be sustained with fervency. This is the season of
              steadfastly keeping the commandments of charity towards the
              brethren and towards God. Because the Bridegroom — the Son of God
              — expects to find the believer actively doing the will of the
              Lord, not growing slack, losing zeal for obedience, or fading in
              faithfulness, this reflects a posture of watchful expectation,
              living in readiness for the coming of the Lord{" "}
              <b>(Mark 13:34-37; Malachi 3:1)</b>. The five foolish virgins
              failed in this — they ceased in their watchfulness and obedience,
              and so were not accepted at the coming of the Bridegroom{" "}
              <b>(Matthew 25:1–13)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>
                B. The Hebrew Church, the Church in the Accepted Time
              </Subtitle>
              In the days of the early church, we find a church who were able to
              come to the season of the accepted time. We know this because we
              find some interesting words or phrases that point us in this
              direction:
            </Content>
            <Number number="A">
              <b>Hebrews 3:1.</b> They are referred to as holy brethren,
              partakers of the heavenly calling. He emphasises that they should
              consider the Apostle and High Priest, Jesus Christ.
            </Number>
            <Number number="B">
              <b>Hebrews 4:13.</b> They were admonished to give heed in a time
              called <b>"To Day"</b>. This shows they were approaching the Day
              of God.
            </Number>
            <Number number="C">
              <b>Hebrews 6:1.</b> They are to go on to perfection. This shows
              that the doorway into the day of God was opened to them.
            </Number>
            <Number number="D">
              <b>Hebrews 10:39.</b> They were admonished to go on to the saving
              of their souls.
            </Number>
            <Number number="E">
              <b>Hebrews 13:21.</b> They were prayed for to be perfected in
              every good work to do his will.
            </Number>
            <Content>
              This shows us that the Hebrews were expected to go on to be
              perfected, beautified, or saved.
            </Content>
          </SubSection>
        </Section>
      </Section>

      {/* Conclusion */}
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            We thank God for the great help we have received in this year's
            Gadites Bible Seminar to understand the volume of his beautiful
            will. It is clear that it is the desire of God that man will do and
            finish all his will, pleasing him to the uttermost and receiving all
            the promises of life in his kingdom. We trust that the Lord has
            inspired our souls to commit our lives to a singular purpose, which
            is to do all the will of God. The whole essence of doing the will of
            God is to save our souls. We pray that God will make us the
            generation that will finish his will in Jesus name! See you next
            year!
          </Content>
        </SubSection>
      </Section>

      <WithLove />
    </>
  );
}
